import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadVehicleRegistryListSuccessful,
  loadVehicleRegistryListFailed, loadVehicleRegistryListBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadVehicleRegistryList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
      include: 'registryVehicle,carrierVehicles,driver,applicants',
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      // pool = { ...pool, filter: getExistFields(filter) };
      pool.filter = addFilterQuery(filter);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL_V2}/dict/vehicles/search`;
    yield put(loadVehicleRegistryListBegin());

    const response = yield makeRequest(url, pool, action, 'POST', true);
    const responseData = yield response.json();
    if (response.status === OK) {
      yield put(loadVehicleRegistryListSuccessful(responseData));
      yield call(resolveActionPromise(action, responseData));
    } else {
      yield put(loadVehicleRegistryListFailed());
      yield call(rejectActionPromise(action, responseData));
    }
  } catch (e) {
    yield put(loadVehicleRegistryListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
